export const AnnotationStyles = {
  defaultExpandable: 'defaultExpandable',
  blueHover: 'blueHover', // TODO CARSAT
  orangeHover: 'orangeHover', // TODO CARSAT
  dangerAlwaysOpened: 'dangerAlwaysOpened', // TODO CARSAT
  dangerClick: 'dangerClick', // TODO CARSAT
  orangeFixed: 'orangeFixed' // TODO CARSAT
};
